import styled from '@emotion/styled';

export const MultiplePatientsButtonsWrapper = styled.div<{
  justifyContent?: string;
  noPadding?: boolean;
  toDisplay?: boolean;
}>(
  {
    display: 'inline-flex',
    width: '100%',
    '@media screen and (max-width: 576px)': {
      display: 'none !important',
    },
  },
  ({ justifyContent, noPadding, toDisplay }) => ({
    display: toDisplay ? 'inline-flex' : 'none',
    justifyContent: justifyContent,
    padding: noPadding ? undefined : '1rem',
  }),
);

export const MultiplePatientsButtonsWrapperMobile = styled.div<{
  justifyContent?: string;
}>(
  {
    display: 'inline-flex',
    width: '100%',
    '@media screen and (min-width: 577px)': {
      display: 'none !important',
    },
  },
  ({ justifyContent }) => ({
    justifyContent: justifyContent,
  }),
);
